import Domains from "../../apis/Domains";
import User from "../../apis/User.js";
import router from "../../router";

const state = {
  domains: [],
  domainUrlsList: [],
  errorDomain: "",
};

const getters = {
  selectedDomain: (state) => (id) =>
  {
    if (id || id == 0) {
      return state.domains.find((el) => el.id == id) !== undefined ? state.domains.find((el) => el.id == id).url || state.domains.find((el) => el.id == id).url : null;
    } else {
      return "Select Website";
    }
  },
  getDomainUrl: (state) => (id) =>
  {
    if (id) {
      return state.domains.find((el) => el.id == id) !== undefined ? state.domains.find((el) => el.id == id).url.split("https://")[1] || state.domains.find((el) => el.id == id).url : null;
    }
  },
  selectedDomainById: (state) => (id) =>
  {
    if (id || id == 0) {
      try {
        return state.domains.find((el) => el.id == id) !== undefined ? state.domains.find((el) => el.id == id) : null;
      } catch (e) {
        console.error(e?.message || e);
        throw new Error(e?.message || e);
      }
    } else {
      return "Select Website";
    }
  },
  selectedDomainWebsite: (state) => (id) =>
  {
    if (id || id == 0) {
      return state.domains.find((el) => el.website_id == id);
    }
  },
  selectedDomainWebsiteId: (state) => (id) =>
  {
    console.log(id, state.domains.find((el) => el.website_id == id))
    return state.domains.find((el) => el.website_id === id);
  },

  domainUrls(state)
  {
    for (let i in state.domains[0]) {
      state.domainUrlsList.push(state.domains[0][i].url);
    }

    return state.domainUrlsList;
  }
};

const actions = {
  async obtainSelectedClientsDomains({ commit }, { params = "?with[domain_tags]=*", selectedClients })
  {
    try {
      const requests = selectedClients.map(id => Domains.get(params, { client: id }));
      const responses = await Promise.allSettled(requests);

      responses.forEach((result, index) =>
      {
        console.log("🚀 ~ responses.forEach ~ result:", result);
        if (result.status !== 'fulfilled') {
          console.error(`Request ${index + 1} failed:`, result.reason);
          //throw new Error(`Request ${index + 1} failed:`, result.reason);
        }
      });

      const mergedResponses = responses.map(res =>
      {
        return res.status === "fulfilled" ? res.value.data.data : [];
      });
      console.log("🚀 ~ mergedResponses:", mergedResponses);

      let flatResponse = mergedResponses.flat(Infinity);

      commit("GET_CLIENT_DOMAINS", flatResponse);
    } catch (e) {
      // commit("GET_CLIENT_DOMAINS", []);
      commit("DETECT_ERROR", e?.message || e);
      //throw new Error(e?.message || e);
    }
  },
  obtainClientDomains({ commit }, { params = "?with[domain_tags]=*", headers })
  {
    return new Promise((resolve, reject) =>
    {
      if (router.currentRoute.name !== "Register") {
        Domains.get(params, headers)
          .then((response) =>
          {
            resolve(response);
            commit("GET_CLIENT_DOMAINS", response.data.data);
          })
          .catch((error) =>
          {
            reject(error);
            if (error.response) {
              commit("GET_CLIENT_DOMAINS", []);
              commit("DETECT_ERROR", error.response);
            }
          });
      }
    });
  },
  show({ commit }, { id = "", headers = {} } = {})
  {
    return new Promise((resolve, reject) =>
    {
      if (router.currentRoute.name !== "Register") {
        Domains.get("?with[domain_tags]=*", headers)
          .then((response) =>
          {
            resolve(response);
            commit("GET_DOMAINS", response.data.data);
          })
          .catch((error) =>
          {
            reject(error);
            if (error.response) {
              commit("GET_DOMAINS", []);
              commit("DETECT_ERROR", error.response);
            }
          });
      }
    });
    // return new Promise((resolve, reject) => {
    //   Domain.show(id)
    //     .then((response) => {
    //       resolve(response);
    //       commit("GET_DOMAINS", response.data.data);
    //     })
    //     .catch((error) => {
    //       reject(error);
    //       if (error.response) {
    //         commit("GET_DOMAINS", []);
    //         commit("DETECT_ERROR", error.response);
    //       }
    //     })
    // })
  },

  resetDomains({ commit })
  {
    commit("RESET_DOMAINS");
  },

  addTags({ commit }, data)
  {
    let urlParams = data.array.map((el) =>
    {
      return "tags[]=" + el.name;
    }).join('&');

    return new Promise((resolve, reject) =>
    {
      Domains.addTags(data.website_id, urlParams)
        .then((response) =>
        {
          resolve(response);
          commit("ADD_TAGS", { website_id: data.website_id, array: data.array });
        })
        .catch((error) =>
        {
          reject(error);
          if (error.response) {
            commit("DETECT_ERROR", error.response);
          }
        });
    });
  },

  removeTags({ commit }, data)
  {
    return new Promise((resolve, reject) =>
    {
      Domains.removeTags(data.website_id, `tags[]=${data.tag}`)
        .then((response) =>
        {
          resolve(response);
          commit("REMOVE_TAG", { website_id: data.website_id, tag: data.tag });
        })
        .catch((error) =>
        {
          reject(error);
          if (error.response) {
            commit("DETECT_ERROR", error.response);
          }
        });
    });
  },

  delete({ commit }, id)
  {
    Domains.delete(id)
      .then(() =>
      {
        commit("DELETE_DOMAIN", id);
      })
      .catch((error) =>
      {
        commit("DETECT_ERROR", error.response);
      });
  },

  store({ commit }, json)
  {
    Domains.store(json)
      .then((response) =>
      {
        commit("STORE_DOMAIN", response["data"]["data"]);
      })
      .catch((error) =>
      {
        commit("DETECT_ERROR", error.response);
      });
  },

  update({ commit }, data)
  {
    return new Promise((resolve, reject) =>
    {
      Domains.update(data.id, data.json)
        .then((response) =>
        {
          commit("UPDATE_DOMAIN", response.data.data);
          resolve(response.data.data);
        })
        .catch((error) =>
        {
          commit("DETECT_ERROR", error.response);
          reject(error);
        });
    });
  },
};

const mutations = {
  GET_DOMAINS(state, domains)
  {
    state.domains = domains;
  },
  GET_CLIENT_DOMAINS(state, domains)
  {
    state.domains = domains;
  },

  RESET_DOMAINS(state)
  {
    state.domains = [];
  },

  DELETE_DOMAIN(state, id)
  {
    let obj = state.domains.findIndex((el) => el.id == id);
    state.domains.splice(obj, 1);
  },

  UPDATE_DOMAIN(state, domains)
  {
    let index = state.domains.findIndex((el) => el.id == domains.id);
    state.domains[index] = domains;
  },

  ADD_TAGS(state, data)
  {
    let domain = state.domains.find(el => el.website_id == data.website_id);

    data.array.forEach(el =>
    {
      domain.domain_tags.push({ id: el.id, name: el.name, type: el.type });
    });
  },

  REMOVE_TAG(state, data)
  {
    let domain = state.domains.find(el => el.website_id === data.website_id);
    let tagIndex = domain.domain_tags.findIndex(el => el.name === data.tag);

    domain.domain_tags.splice(tagIndex, 1);
  },
  DETECT_ERROR(state, error)
  {
    if (error.status == 401 || error.status == 419) {
      User.logout().then(() =>
      {
        localStorage.removeItem("auth");
        //localStorage.removeItem("login");
        router.push({ name: "Login", path: router.currentRoute.path });
      });
    } else if (error.data.message !== undefined) {
      state.errorDomain = error.data.message;
    }

    setTimeout(() =>
    {
      state.errorDomain = "";
    }, 1000);
  },
};

export default {
  state,
  actions,
  getters,
  mutations,
};
